import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertyPromoteSectionComponent } from '../../../sections/property-default-sections/property-promote-section/property-promote-section.component';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';
import { PropertyPageBase } from '../../property-page-base';

@Component({
    selector: 'property-promote-page',
    templateUrl: './property-promote-page.component.html',
    styleUrls: ['./property-promote-page.component.scss'],
    standalone: false
})
export class PropertyPromotePageComponent
    extends PropertyPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild(PropertyPromoteSectionComponent, {
        read: PropertyPromoteSectionComponent
    })
    propertyPromoteSectionComponent: PropertyPromoteSectionComponent;

    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertyPromote, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(this.propertyPromoteSectionComponent);
    }
}
